import React from "react";

const DownloadIcon = (props) => {
  const { height = "24", width = "24", color = "#eee" } = props;
  return (
    //         <svg width={width} height={height} viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
    //     <g fill="none" fillRule="evenodd">
    //         <path d="M.5.876h24v24H.5z"/>
    //         <path d="M2 23.376a1.5 1.5 0 0 1 1.5-1.5h18a1.5 1.5 0 0 1 0 3h-18a1.5 1.5 0 0 1-1.5-1.5zm4.939-11.56a1.5 1.5 0 0 1 2.121 0l1.94 1.94V2.375a1.5 1.5 0 0 1 3 0v11.38l1.939-1.94a1.5 1.5 0 1 1 2.121 2.12l-4.5 4.5a1.5 1.5 0 0 1-2.121 0l-4.5-4.5a1.5 1.5 0 0 1 0-2.12z" fill={color} fillRule="nonzero"/>
    //     </g>
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 74 113"
      width={width}
      height={height}
    >
      <path
        d="M34.559 92.3938C34.713 92.5478 34.8827 92.686 35.0635 92.8065L35.3028 92.9391L35.5819 93.0717L35.9009 93.1784L36.193 93.2711L36.1939 93.2711C36.6326 93.361 37.0842 93.361 37.5228 93.2711L37.8149 93.1784L38.1339 93.0717L38.4659 92.8992L38.7051 92.7666L38.7061 92.7666C38.8878 92.6461 39.0566 92.5079 39.2115 92.354L63.4329 68.1729C64.733 66.8737 64.733 64.7658 63.4329 63.4668C62.1337 62.1676 60.0267 62.1676 58.7268 63.4668L40.2349 81.9725L40.2349 3.3235C40.2349 1.48832 38.7465 -2.61322e-05 36.9113 -2.62927e-05C35.0762 -2.64531e-05 33.5878 1.48832 33.5878 3.3235L33.5878 81.9725L15.0959 63.4799C13.7958 62.1807 11.6888 62.1807 10.3898 63.4799C9.0897 64.78 9.0897 66.887 10.3898 68.186L34.559 92.3938Z"
        fill={color}
      />
      <path
        d="M3.67645 112.987L70.1471 112.987C71.9776 112.987 73.4632 111.507 73.4706 109.676L73.4706 90.6392C73.4706 88.8031 71.9822 87.3157 70.1471 87.3157C68.3119 87.3157 66.8235 88.8031 66.8235 90.6392L66.8235 106.34L6.99998 106.34L6.99998 90.6392C6.99998 88.8031 5.51163 87.3157 3.67645 87.3157C1.84127 87.3157 0.352922 88.8031 0.352922 90.6392L0.35292 109.676C0.360339 111.507 1.84592 112.987 3.67645 112.987Z"
        fill={color}
      />
    </svg>
  );
};

export default DownloadIcon;
